export default __webpack_public_path__ + "static/media/woman-profile-01.b0f9e1bb.png";